
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subcategory/[slug]",
      function () {
        return require("private-next-pages/subcategory/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subcategory/[slug]"])
      });
    }
  